export default __webpack_public_path__ + "static/media/2017 LV BOOTH EXPLANATION-MOOD BOARD-01.91cceeee.jpg";